export default __webpack_public_path__ + "static/Foundercrate-a0cdc2933e140cdb89b555194ac464c2.svg";